<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container " >
                <template #default>   <m-Alert-1 v-bind='{...{},...{}}' :style='""' class="col-lg-12 text-center" >
                <template #default>«ارسال کلیه سفارش‌ها طی ۲ تا ۵ روز کاری پس از ثبت و تأیید نهایی انجام خواهد شد.»   </template>
                </m-Alert-1><m-factor-10 v-bind='{...{},...{}}' :style='""' class="" ></m-factor-10></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mAlert1 from '@moeinmdn/miw-alpha-components/src/package/Alert/Alert1'; import mFactor10 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/Factors/Factor10';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mAlert1,mFactor10 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
